import { z } from 'zod';
const SPECIAL_CHARS_REGEX = /[!@#$%^&*()_+\-=[\]{}|;:'",.<>?/\\`~]/;
const LETTERS_REGEX = /[a-zA-Z]/;
const MIN_DIGITS = 8;
export const passwordSchema = z
    .string()
    .refine((password) => !LETTERS_REGEX.test(password), 'Le mot de passe ne doit contenir que des chiffres et des caractères spéciaux')
    .refine((password) => (password.match(/\d/g) ?? []).length >= MIN_DIGITS, 'Le mot de passe doit contenir au moins 8 chiffres')
    .refine((password) => SPECIAL_CHARS_REGEX.test(password), 'Le mot de passe doit contenir au moins un caractère spécial');
